'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const ScoreDistributionInner = dynamic(() => import('./ScoreDistributionInner'), { ssr: false });

export default function ScoreDistributionChart() {
  return <ScoreDistributionInner />;
}